import Marquee from "../Marquee";
import { CAPABILITIES } from "../../data/content";

export default function CapabilityStrip() {
  return (
    <section className="border-y border-[#111827]/8 bg-[#F7F8FA] py-6" data-testid="capability-strip">
      <Marquee items={CAPABILITIES} />
    </section>
  );
}
